// TWC Homepage — Scroll reveal + micro-interactions

(function () {
  'use strict';

  // ── Scroll Reveal ──────────────────────────────────────────────
  function initScrollReveal() {
    // Mark elements for reveal
    const revealTargets = [
      { selector: '.best-sellers__heading',       delay: 0 },
      { selector: '.best-sellers__toggle-wrapper',delay: 1 },
      { selector: '.best-sellers__card:nth-child(1)', delay: 1 },
      { selector: '.best-sellers__card:nth-child(2)', delay: 2 },
      { selector: '.best-sellers__card:nth-child(3)', delay: 3 },
      { selector: '.best-sellers__card:nth-child(4)', delay: 4 },
      { selector: '.best-sellers__card:nth-child(5)', delay: 5 },
      { selector: '.best-sellers__card:nth-child(6)', delay: 6 },
      { selector: '.best-sellers__card:nth-child(7)', delay: 7 },
      { selector: '.best-sellers__card:nth-child(8)', delay: 8 },
      { selector: '.service-restoration__eyebrow',  delay: 0 },
      { selector: '.service-restoration__heading',  delay: 1 },
      { selector: '.service-restoration__toggle-wrapper', delay: 2 },
      { selector: '.service-restoration__panel',    delay: 3 },
      { selector: '.service-restoration__caption',  delay: 4 },
      { selector: '.craftsmanship-video__eyebrow',  delay: 0 },
      { selector: '.craftsmanship-video__heading',  delay: 1 },
    ];

    revealTargets.forEach(({ selector, delay }) => {
      document.querySelectorAll(selector).forEach(el => {
        el.classList.add('twc-reveal', `twc-reveal--delay-${delay}`);
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.twc-reveal').forEach(el => observer.observe(el));
  }

  // ── Smooth tab switching with grid fade ──────────────────────
  function enhanceToggles() {
    document.querySelectorAll('[data-group]').forEach(btn => {
      btn.addEventListener('click', () => {
        // Re-observe newly visible cards
        setTimeout(() => {
          document.querySelectorAll(
            '.best-sellers__grid:not(.best-sellers__grid--hidden) .best-sellers__card,' +
            '.service-restoration__panel:not(.service-restoration__panel--hidden) .before-after-slider'
          ).forEach(el => {
            el.style.opacity = '0';
            el.style.transform = 'translateY(12px)';
            el.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
            requestAnimationFrame(() => {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0)';
            });
          });
        }, 20);
      });
    });
  }

  // ── Run on DOM ready ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initScrollReveal();
      enhanceToggles();
    });
  } else {
    initScrollReveal();
    enhanceToggles();
  }
})();

// ── Back to Top (PLP) ────────────────────────────────────────────────────────
(function () {
  const btn = document.getElementById('twc-back-top');
  if (!btn) return;

  const THRESHOLD = 400;

  window.addEventListener('scroll', function () {
    btn.classList.toggle('twc-back-top--visible', window.scrollY > THRESHOLD);
  }, { passive: true });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

// ── PLP card navigation (replaces card__heading a::after which is disabled for z-index fix) ──
(function () {
  document.addEventListener('click', function (e) {
    const wrapper = e.target.closest('.card-wrapper');
    if (!wrapper) return;
    // Interactive elements handle themselves — don't intercept
    if (e.target.closest('a, button, [role="button"]')) return;
    const link = wrapper.querySelector('a.full-unstyled-link[href]');
    if (link) window.location.href = link.href;
  });
})();

// ── Desktop mega-menu: open pillars on hover (carets removed) ──
(function () {
  function initHoverMenus() {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    document.querySelectorAll('.twc-mega-nav details.mega-menu').forEach(function (details) {
      var li = details.closest('li');
      if (!li || li.dataset.twcHoverBound) return;
      li.dataset.twcHoverBound = '1';
      var closeTimer;
      function open() {
        clearTimeout(closeTimer);
        document.querySelectorAll('.twc-mega-nav details.mega-menu[open]').forEach(function (d) {
          if (d !== details) d.removeAttribute('open');
        });
        if (!details.hasAttribute('open')) details.setAttribute('open', '');
      }
      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { details.removeAttribute('open'); }, 160);
      }
      // The tray is a DOM child of the <li>, so moving into it keeps hover alive
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', scheduleClose);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }
  document.addEventListener('shopify:section:load', initHoverMenus);
})();
